<div id="installer_buttons">
  @if (betaOnly) {
    <h5 class="brandfont-bold">Installers</h5>
  }
  <div class="installer_btn_holder" [class.justify-content-center]="centered" [class.d-flex]="!isSideBar" [class.flex-wrap]="!isSideBar">
    @if ((myOs == "mac" || showAllSystems) && downloads && downloads.installers && downloads.installers.mac) {
      @for (dl of downloads.installers.mac; track dl) {
        <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
          <span (click)="downloadTokenizedAsset(dl)">
            @if (dl.stringId != "capture.public.mac" && dl.stringId != "uc.public.mac") {
              <h6 class="brandfont-bold m-b-10">{{ "product_detail.installer_for" | translate: { os: "Mac" } }}</h6>
              <button class="btn btn-primary">
                @if (product.contractId != "subscriptiontrial") {
                  <i class="fa fa-apple"></i>
                }
                {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
              </button>
            }
            @if (dl.stringId == "capture.public.mac" || dl.stringId == "uc.public.mac") {
              <h6 class="brandfont-bold m-b-10">{{ dl.stringId == "capture.public.mac" ? "Capture" : "Universal Control" }} for Mac</h6>
              <button class="btn btn-primary">
                @if (product.contractId != "subscriptiontrial") {
                  <i class="fa fa-apple"></i>
                }
                {{ "download.download" | translate }}
              </button>
            }
          </span>
          <div>
            <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
            <br />
            <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
          </div>
        </div>
      }
    }
    @if (myOs == "win" || showAllSystems) {
      @if (downloads?.installers?.win) {
        @for (dl of downloads.installers.win; track dl) {
          <div class="m-b-20" [class.installer-btn-pill]="!isSideBar">
            <span (click)="downloadTokenizedAsset(dl)">
              @if (dl.stringId != "capture.public.win" && dl.stringId != "uc.public.win") {
                <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ "product_detail.installer_for" | translate: { os: "Windows (64 bit)" } }}</h6>
                <button class="btn btn-primary">
                  @if (product.contractId != "subscriptiontrial") {
                    <i class="fa fa-windows"></i>
                  }
                  {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
                </button>
              }
              @if (dl.stringId == "capture.public.win" || dl.stringId == "uc.public.win") {
                <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ dl.stringId == "capture.public.win" ? "Capture" : "Universal Control" }} for Windows</h6>
                <button class="btn btn-primary">
                  @if (product.contractId != "subscriptiontrial") {
                    <i class="fa fa-windows"></i>
                  }
                  {{ "download.download" | translate }}
                </button>
              }
            </span>
            <div>
              <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
              <br />
              <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
            </div>
          </div>
        }
      }
      @if (downloads?.installers?.win64) {
        @for (dl of downloads.installers.win64; track dl) {
          <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
            <span (click)="downloadTokenizedAsset(dl)">
              @if (dl.stringId != "capture.public.win" && dl.stringId != "uc.public.win") {
                <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ "product_detail.installer_for" | translate: { os: "Windows (64 bit)" } }}</h6>
                <button class="btn btn-primary">
                  @if (product.contractId != "subscriptiontrial") {
                    <i class="fa fa-windows"></i>
                  }
                  {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
                </button>
              }
              @if (dl.stringId == "capture.public.win" || dl.stringId == "uc.public.win") {
                <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ dl.stringId == "capture.public.win" ? "Capture" : "Universal Control" }} for Windows (64 bit)</h6>
                <button class="btn btn-primary">
                  @if (product.contractId != "subscriptiontrial") {
                    <i class="fa fa-windows"></i>
                  }
                  {{ "download.download" | translate }}
                </button>
              }
            </span>
            <div>
              <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
              <br />
              <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
            </div>
          </div>
        }
      }
      @if (downloads?.installers?.winarm64) {
        @for (dl of downloads.installers.winarm64; track dl) {
          <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
            <span (click)="downloadTokenizedAsset(dl)">
              @if (dl.stringId != "capture.public.winarm64" && dl.stringId != "uc.public.winarm64") {
                <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ "product_detail.installer_for" | translate: { os: "Windows (ARM64)" } }}</h6>
                <button class="btn btn-primary">
                  @if (product.contractId != "subscriptiontrial") {
                    <i class="fa fa-windows"></i>
                  }
                  {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
                </button>
              }
              @if (dl.stringId == "capture.public.winarm64" || dl.stringId == "uc.public.winarm64") {
                <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ dl.stringId == "capture.public.winarm64" ? "Capture" : "Universal Control" }} for Windows (ARM64)</h6>
                <button class="btn btn-primary">
                  @if (product.contractId != "subscriptiontrial") {
                    <i class="fa fa-windows"></i>
                  }
                  {{ "download.download" | translate }}
                </button>
              }
            </span>
            <div>
              <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
              <br />
              <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
            </div>
          </div>
        }
      }
    }

    @if ((myOs == "linux" || showAllSystems) && downloads && downloads.installers && downloads.installers.linux) {
      @for (dl of downloads.installers.linux; track dl) {
        <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
          <span (click)="downloadTokenizedAsset(dl)">
            <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ "product_detail.installer_for" | translate: { os: "Linux (deb)" } }}</h6>
            <button class="btn btn-primary">
              @if (product.contractId != "subscriptiontrial") {
                <i class="fa fa-linux"></i>
              }
              {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
            </button>
          </span>
          <div>
            <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
            <br />
            <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
          </div>
        </div>
      }
    }

    @if ((myOs == "linux" || showAllSystems) && downloads && downloads.installers && downloads.installers.flatpak) {
      @for (dl of downloads.installers.flatpak; track dl) {
        <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
          <span (click)="downloadTokenizedAsset(dl)">
            <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">{{ "product_detail.installer_for" | translate: { os: "Linux (flatpak)" } }}</h6>
            <button class="btn btn-primary">
              @if (product.contractId != "subscriptiontrial") {
                <i class="fa fa-linux"></i>
              }
              {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
            </button>
          </span>
          <div>
            <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
            <br />
            <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
          </div>
        </div>
      }
    }
    @if (downloads && downloads.installers && downloads.installers.all) {
      @for (dl of downloads.installers.all; track dl) {
        <div class="m-b-10" [class.installer-btn-pill]="!isSideBar">
          <span (click)="downloadTokenizedAsset(dl)">
            <h6 class="brandfont-bold m-b-10" [class.m-t-20]="isSideBar">Installer</h6>
            <button class="btn btn-primary">
              @if (product.contractId != "subscriptiontrial") {
                <fa-icon icon="download"></fa-icon>
              }
              {{ (product.contractId == "subscriptiontrial" ? "product_detail.start_trial" : "download.download") | translate }}
            </button>
          </span>
          <small class="text-muted d-block m-t-10">{{ dl.title }}</small>
          <div>
            <span [class]="dl.beta ? 't-12 c-green' : 't-12'">{{ dl.beta ? "BETA v" : "v" }}{{ dl.version }}</span>
            <br />
            <span class="text-muted d-block t-12">{{ dl.releaseDate | date }}</span>
          </div>
        </div>
      }
    }
  </div>

  @if (product.partnerName && product.partnerName == "pace") {
    <div>
      {{ "products.requires_ilok" | translate }} -
      <span class="btn btn-sm btn-primary" (click)="showiLokOverlay()">{{ "general.learn_more" | translate }}</span>
    </div>
  }

  @if (product.partnerDownloadUrl && product.partnerName != "pace" && product.stringId != "eastwest.composercloud") {
    <div class="installer_btn_holder" [class.justify-content-center]="centered">
      <a (click)="ga.trackOutboundLink(product.partnerDownloadUrl)">
        @if (product.contractId == "subscriptiontrial") {
          <button class="btn btn-primary">
            {{ "product_detail.start_trial" | translate }}
          </button>
        }
        @if (product.contractId != "subscriptiontrial" && !product.partnerDownloadUrl) {
          <button class="btn btn-primary">
            <fa-icon icon="download"></fa-icon>
            {{ "product_detail.download_installer" | translate }}
          </button>
        }
        @if (product.partnerDownloadUrl) {
          <button class="btn btn-primary">
            {{ (product.stringId == "splicebundle" ? "product_detail.start_trial" : "general.redeem") | translate }}
          </button>
        }
      </a>
    </div>
  }
  @if (hasNoInstallers && betaOnly) {
    <div class="text-muted m-b-30">No beta installers are available for this product.</div>
  }
</div>

@if (firmwareList?.length || (betaOnly && product.categoryId == "hardware")) {
  <div class="m-b-10">
    @if (betaOnly) {
      <h5 class="brandfont-bold">Firmware</h5>
    }
    @if (!betaOnly) {
      @if (firmwareList?.length) {
        <div class="installer_btn_holder" [class.justify-content-center]="centered">
          <a (click)="showFirmwareInstructions(firmwareList[0])">
            <button class="btn btn-primary">
              <fa-icon icon="download"></fa-icon>
              {{ "product_detail.get_latest_firmware" | translate }}
            </button>
          </a>
          <br />
          <span [class]="firmwareList[0].beta ? 't-12 c-green' : 't-12'">{{ (firmwareList[0].beta ? "BETA " : "") + "Version " + firmwareList[0].version }}</span>
        </div>
      }
    }
    @if (betaOnly && firmwareList?.length) {
      @for (fw of firmwareList; track fw) {
        <div class="installer_btn_holder m-b-10" [class.justify-content-center]="centered">
          <a (click)="showFirmwareInstructions(fw)">
            <button class="btn btn-primary">
              <fa-icon icon="download"></fa-icon>
              Firmware
            </button>
          </a>
          <br />
          <span class="t-12 bold">Beta Version {{ fw.version }}</span>
          <br />
          <span class="t-12">{{ fw.filename }}</span>
        </div>
      }
    }
    @if (!firmwareList?.length && betaOnly) {
      <div class="text-muted m-b-30">No beta firmware is available for this product.</div>
    }
  </div>
}

@if (!betaOnly || !hasNoInstallers) {
  <div class="installer_btn_actions m-t-20" [class.text-center]="centered">
    @if (downloads && downloads.installers && downloads.installers.mac && (downloads.installers.win || downloads.installers.win64)) {
      <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" (click)="showAllSystems = !showAllSystems">
        <span>{{ (showAllSystems ? "product_detail.show_my_system" : "product_detail.show_all_systems") | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
    @if (previousVersions && previousVersions.length) {
      <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" (click)="showPreviousVersions()">
        <span>{{ "product_detail.view_previous_versions" | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
    @if (downloads && downloads.release_notes) {
      <button
        [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'"
        (keyup.enter)="downloadTokenizedAsset(downloads.release_notes[0])"
        (click)="downloadTokenizedAsset(downloads.release_notes[0])"
      >
        <span>{{ "product_detail.download_release_notes" | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
    @if (showManageActivations) {
      <button [class]="isSideBar ? 'sidebar-btn' : 'brand-btn-reverse sm m-r-10'" [routerLink]="['/account/plan']">
        <span>{{ "product_detail.activations.manage_title" | translate }}</span>
        &nbsp;
        <fa-icon icon="chevron-right"></fa-icon>
      </button>
    }
  </div>
}
